import { render, staticRenderFns } from "./traceability_item.vue?vue&type=template&id=19141f92&scoped=true&"
import script from "./traceability_item.vue?vue&type=script&lang=js&"
export * from "./traceability_item.vue?vue&type=script&lang=js&"
import style0 from "./traceability_item.vue?vue&type=style&index=0&id=19141f92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19141f92",
  null
  
)

export default component.exports